import { aclPermsType, contractorPermsTypes, ccdPermsTypes, tenantPermsTypes, tmsPermsTypes } from '@/utils/aclHelper'
import store from '@/store'

export const userTypePageAcl = {
  engineer: () => store.getters['user/isEngineer'],
  tenant: () => store.getters['user/isTenant'],
  vendor: () => store.getters['user/isContractor'],
  common: () => true,
}

const publicPermsTypesForUsersDeparts = [
  aclPermsType.settings.read,
  aclPermsType.itqTenderDocuments.readUpdate,
  aclPermsType.thresholds.readUpdate,
  aclPermsType.departmentVendors.read,
  aclPermsType.vendorECircular.manageECircularContact,
]

const aclMeta = {
  settings: {
    permTypes: [ aclPermsType.settings.read ],
  },
  settingsRegional: {
    permTypes: [ aclPermsType.settings.readRegional ],
  },
  settingsUsers: {
    permTypes: [
      ...publicPermsTypesForUsersDeparts,
      aclPermsType.settings.readVendors,
    ],
  },
  settingsDeparts: {
    permTypes: publicPermsTypesForUsersDeparts,
  },
  tenderEdit: {
    permTypes: [aclPermsType.tenders.createUpdate, aclPermsType.tenders.review],
    fallback: 'tenderDetailsView',
  },
  tenderAddendumEdit: {
    permTypes: [aclPermsType.tenders.createUpdate, aclPermsType.tenders.review],
    fallback: 'tenderAddendumDetailsView',
  },
  tenderView: {
    permTypes: [
      aclPermsType.tenders.read,
      aclPermsType.tenders.createUpdate,
      aclPermsType.tenders.approve,
      aclPermsType.tenders.review,
    ],
  },
  projectView: {
    permTypes: [aclPermsType.projects.manage, aclPermsType.projects.read, aclPermsType.projects.review, tmsPermsTypes.workpermit.read],
  },
  contractorTender: {
    permTypes: [contractorPermsTypes.tenders.readUpdate],
    fallback: 'vendorHome',
    contractorView: true,
  },
  contractorReviewTender: {
    permTypes: [contractorPermsTypes.tenders.review],
    fallback: 'vendorHome',
    contractorView: true,
  },
  contractorProject: {
    permTypes: [contractorPermsTypes.projects.readUpdate, contractorPermsTypes.projects.review, contractorPermsTypes.projectContractor.readUpdate],
    fallback: 'vendorHome',
    contractorView: true,
  },
  contractorSettings: {
    permTypes: [contractorPermsTypes.settings.read],
    fallback: 'vendorHome',
    contractorView: true,
  },
  directory: {
    permTypes: [tmsPermsTypes.directory.read, tmsPermsTypes.directory.approve, tmsPermsTypes.directory.maintain],
  },
  directoryRead: {
    permTypes: [tmsPermsTypes.directory.read],
  },
  directoryMaintain: {
    permTypes: [tmsPermsTypes.directory.maintain, tmsPermsTypes.directory.removeFromMaintain],
  },
  exportEmergency: {
    permTypes: [ccdPermsTypes.exportContact.exportEmergency],
  },
  exportMarketing: {
    permTypes: [ccdPermsTypes.exportContact.exportMarketing],
  },
  exportFireMarshal: {
    permTypes: [ccdPermsTypes.exportContact.exportFireMarshal],
  },
  workPermit: {
    permTypes: [tmsPermsTypes.workpermit.read],
  },
  exportWorkPermits: {
    permTypes: [ccdPermsTypes.exportContact.exportWorkPermit],
  },
  exportContacts: {
    permTypes: [
      ccdPermsTypes.exportContact.exportEmergency,
      ccdPermsTypes.exportContact.exportMarketing,
      ccdPermsTypes.exportContact.exportFireMarshal,
      tmsPermsTypes.workpermit.read,
      ccdPermsTypes.exportContact.exportWorkPermit,
    ],
  },
  tenancyRecord: {
    permTypes: [ccdPermsTypes.tenancy.read, ccdPermsTypes.tenancy.review],
  },

  hotb: {
    permTypes: [tmsPermsTypes.hotb.read],
  },

  tenancyRecordCreateUpdate: {
    permTypes: [tenantPermsTypes.tenancies.readUpdate,
      ccdPermsTypes.tenancy.create,
      ccdPermsTypes.tenancy.update,
      ccdPermsTypes.tenancy.inviteMaster,
      ccdPermsTypes.tenancy.linkLeases,
      ccdPermsTypes.tenancy.linkContacts,
      ccdPermsTypes.tenancy.changeCompanyName,
      ccdPermsTypes.tenancy.updateTenancyMasterAccount,
    ],
  },

  companyDetail: {
    permTypes: [ccdPermsTypes.contractor.read, ccdPermsTypes.organization.read, ccdPermsTypes.tenant.read],
  },
  companyCreate: {
    permTypes: [ccdPermsTypes.organization.createUpdate],
  },
  companyDetailCreateUpdate: {
    permTypes: [ccdPermsTypes.contractor.createUpdate, ccdPermsTypes.organization.createUpdate, ccdPermsTypes.tenant.createUpdate],
  },
  ccdContactDetail: {
    permTypes: [ccdPermsTypes.contact.read, ccdPermsTypes.contact.read],
  },
  ccdContactDetailCreateUpdate: {
    permTypes: [ccdPermsTypes.contact.read, ccdPermsTypes.contact.createUpdate],
  },
  performance: {
    permTypes: [aclPermsType.performance.read],
  },
  projectRatingHistory: {
    permTypes: [ccdPermsTypes.contractor.read],
  },
  eCircularCreate: {
    permTypes: [tmsPermsTypes.tenantEcircular.createUpdate, aclPermsType.vendorECircular.createUpdateSelectSendCancel],
  },
  eCircularDetail: {
    permTypes: [tmsPermsTypes.tenantEcircular.read, aclPermsType.vendorECircular.read],
  },
  eCircularAddRecipient: {
    permTypes: [tmsPermsTypes.tenantEcircular.send, aclPermsType.vendorECircular.createUpdateSelectSendCancel],
  },
}

export default aclMeta
